import blackTable from '../../../../assets/images/tables/table_black.svg'
import blueTable from '../../../../assets/images/tables/table_blue.svg'
import greenTable from '../../../../assets/images/tables/table_green.svg'
import redTable from '../../../../assets/images/tables/table_red.svg'
import { ETableColor } from '../../../../store/atoms/userSettings'

export const tableSourceByColor: Record<ETableColor, string> = {
  [ETableColor.BLUE]: blueTable,
  [ETableColor.BLACK]: blackTable,
  [ETableColor.GREEN]: greenTable,
  [ETableColor.RED]: redTable,
}
